import { i18nCustom } from "~/services/service/i18n-service"

export function getLocalizedPlanName(name: string): string {
	if (!name?.includes("-")) return ""

	const [num, title] = name.split("-")
	return `${num}-${i18nCustom._(title)}`
}
